{
  "stepper": {
    "title": "Progression du suivi",
    "discardReason": "Motif : {{comment}}",
    "readyToScheduleVisit": "Prêt à planifier une visite",
    "dateLabel": "Date :",
    "addressLabel": "Adresse :",
    "commentLabel": "Commentaire :"
  },
  "commentForm": {
    "defaultTitle": "Ajouter un commentaire",
    "commentLabel": "Commentaire",
    "commentPlaceholder": "Saisissez votre commentaire ici...",
    "commentRequired": "Le commentaire est requis",
    "submit": "Envoyer"
  },
  "visitSchedule": {
    "title": "Planifier une visite",
    "dateLabel": "Date et heure de la visite",
    "addressLabel": "Adresse de la visite",
    "addressPlaceholder": "Saisissez l'adresse complète de la visite",
    "dateRequired": "La date de visite est requise",
    "dateInFuture": "La date de visite doit être dans le futur",
    "addressRequired": "L'adresse de visite est requise",
    "submit": "Planifier"
  }
}
